import React from 'react';
import { Badge, getInvoiceStatusVariant, getSubscriptionStatusVariant, getPaymentStatusVariant } from '../ui/Badge';
import { InvoiceStatus, SubscriptionStatus, PaymentStatus } from '../../types';
interface InvoiceStatusBadgeProps {
  status: InvoiceStatus;
}
export function InvoiceStatusBadge({
  status
}: InvoiceStatusBadgeProps) {
  const getVariant = () => {
    switch (status) {
      case 'paid':
      case 'approved':
        return 'success';
      case 'sent':
        return 'warning';
      case 'draft':
      case 'quote':
        return 'info';
      case 'refunded':
      case 'voided':
        return 'danger';
      default:
        return 'default';
    }
  };
  const getLabel = () => {
    return status.charAt(0).toUpperCase() + status.slice(1);
  };
  return <Badge variant={getVariant()} data-id="element-225">{getLabel()}</Badge>;
}
interface SubscriptionStatusBadgeProps {
  status: SubscriptionStatus;
}
export function SubscriptionStatusBadge({
  status
}: SubscriptionStatusBadgeProps) {
  return <Badge variant={getSubscriptionStatusVariant(status)} data-id="element-226">
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Badge>;
}
interface PaymentStatusBadgeProps {
  status: PaymentStatus;
}
export function PaymentStatusBadge({
  status
}: PaymentStatusBadgeProps) {
  return <Badge variant={getPaymentStatusVariant(status)} data-id="element-227">
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Badge>;
}